export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    DEVICE_QUICK_LOGIN_ALL: function DEVICE_QUICK_LOGIN_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/device-quick-login/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    DEVICE_QUICK_LOGIN_CREATE: function DEVICE_QUICK_LOGIN_CREATE(data) {
      return request({
        url: '/api/device-quick-login/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_QUICK_LOGIN_DETAIL: function DEVICE_QUICK_LOGIN_DETAIL(id) {
      return request({
        url: '/api/device-quick-login/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_QUICK_LOGIN_UPDATE: function DEVICE_QUICK_LOGIN_UPDATE(data) {
      return request({
        url: '/api/device-quick-login/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    DEVICE_QUICK_LOGIN_DELETE: function DEVICE_QUICK_LOGIN_DELETE(id) {
      return request({
        url: '/api/device-quick-login/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});